import React from 'react';
import { useTranslation } from 'react-i18next';

import Screen from '../../components/common/Screen';
import Card from '../../components/elements/Card';
import Title from '../../components/common/Title';
import Icon from '../../components/common/Icon';

// Shown after a successful public form submission. `message` is the form's own
// thank-you text (may be empty) — fall back to a generic confirmation. `homeButton`
// is the caller's way out of this dead end (null when embedded in a host page).
// `accent` is the owning BU's brand colour, carried over from the form itself so the
// tick and the way out stay the brand's colour instead of snapping back to ours.
const FormThankYou = ({ message, embed = false, homeButton = null, accent = null }) => {
  const { t } = useTranslation();
  const accentStyle = accent ? { '--primary-color': accent } : undefined;

  const content = (
    <Card>
      <div className="d-flex flex-column align-items-center text-center py-3">
        <Icon name="check-circle" theme="primary" style={{ fontSize: '48px' }} className="mb-3" />
        <Title>{t('formThankYouTitle')}</Title>
        <p className="text-muted">
          {(message && message.trim()) ? message : t('formThankYouDefault')}
        </p>
        {homeButton}
      </div>
    </Card>
  );

  if (embed) {
    return <div className="tornea-form-embed" style={{ padding: '10px', maxWidth: '640px', margin: '0 auto', ...(accentStyle || {}) }}>{content}</div>;
  }
  return (
    <Screen>
      <div className="top" style={accentStyle}>{content}</div>
    </Screen>
  );
};

export default FormThankYou;
